export const spaces = {
    'space_96' : '96px',
    'space_88' : '88px',
    'space_82' : '82px',
    'space_80' : '80px',
    'space_72' : '72px',
    'space_64' : '64px',
    'space_56' : '56px',
    'space_48' : '48px',
    'space_40' : '40px',
    'space_36' : '36px',
    'space_32' : '32px',
    'space_28' : '28px',
    'space_24' : '24px',
    'space_20' : '20px',
    'space_16' : '16px',
    'space_12' : '12px',
    'space_8' : '8px',
    'space_4' : '4px',
    'space_2' : '2px',
    'space_0' : '0px',    
} as const;

export const widths = {
    'width_full' : '100%',
    'width_vw' : '100vw',
    'width_1680' : '1680px',
    'width_1568' : '1568px',
    'width_1300' : '1300px',
    'width_1280' : '1280px',
    'width_1160' : '1160px',
    'width_1100' : '1100px',
    'width_966' : '966px',
    'width_926' : '926px',
} as const;
